import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { logout, isLoggedIn, CheckRole } from "../../Services/AuthService";
import UserInfo from "./UserInfo";
import UsrProfImg from "../../assets/user.png";
import logoImage from "../../assets/logo.png";
import NavbarMobile from "./NavbarMobile";
import "./Navbar.css";
import MenuList from "./MenuList";
import { useTenantContent } from "../../Context/TenantContentContext";
import { getTenantNavVisibility } from "./tenantNavVisibility";
import { getTenantFilteredMenuItems } from "./tenantNavMenu";

const Navbar = () => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const { content, loading } = useTenantContent();
  const navMenuItems = useMemo(
    () => getTenantFilteredMenuItems(content),
    [content],
  );
  const { showReservation, showBlog, showConsultation } =
    getTenantNavVisibility(content, loading);
  const isDoctor = CheckRole(["Doctor"]);
  const counselingPath = isDoctor
    ? "/counseling/doctorChats"
    : "/counseling/index";
  const counselingState = isDoctor ? { status: "active" } : undefined;
  const userFirstName = localStorage.getItem("userFirstName");
  const userLastName = localStorage.getItem("userLastName");

  const fullName = `${userFirstName || ""} ${userLastName || ""}`.trim();

  const handleNavigation = (path, state = null) => {
    if (state != null) {
      navigate(path, { state: state });
    } else {
      navigate(path);
    }
    setAnchorElUser(null);
  };

  const handleClose = () => {
    setAnchorElUser(null);
  };

  const handleUserIconClick = (event) => {
    if (isLoggedIn()) {
      if (anchorElUser) {
        setAnchorElUser(null);
      } else {
        setAnchorElUser(event.currentTarget);
      }
    } else {
      navigate("/login");
    }
  };

  const handleLogout = () => {
    logout();
    handleClose();
    navigate("/login");
  };

  return (
    <>
      <nav
        className="navbar bg-white navbar-expand-lg border-bottom fixed-top p-0 iran-sans"
        dir="ltr"
      >
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="col-2 m-0 p-0 d-flex align-items-center">
            <Link to="/" className="ps-1 m-0">
              <img
                className="m-1 ms-0 p-0 ms-md-2"
                src={logoImage}
                alt={content?.siteName || "لوگوی سایت"}
                width="43"
                height="43"
              />
            </Link>
          </div>

          {/* Center Items */}
          <div className="col-8 justify-content-center">
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto me-auto mb-2 mb-lg-0 me-4">
                <li className="nav-item bg-white">
                  <Link
                    to={"/support"}
                    className="nav-link active me-4 home-topic"
                  >
                    پشتیبانی
                  </Link>
                </li>
                <li className="nav-item bg-white">
                  <Link
                    to={"/about"}
                    className="nav-link active me-4 home-topic"
                  >
                    درباره پزشک
                  </Link>
                </li>
                {showBlog && (
                  <li className="nav-item bg-white">
                    <Link
                      to={"/blog/index"}
                      className="nav-link active me-4 home-topic"
                    >
                      مقالات
                    </Link>
                  </li>
                )}
                {showConsultation && (
                  <li className="nav-item bg-white">
                    <Link
                      to={counselingPath}
                      state={counselingState}
                      className="nav-link active me-4 home-topic"
                    >
                      مشاوره
                    </Link>
                  </li>
                )}
                {showReservation && (
                  <li className="nav-item bg-white">
                    <Link
                      to={"/reservation/reserve"}
                      className="nav-link active me-4 home-topic"
                    >
                      رزرو نوبت
                    </Link>
                  </li>
                )}
                <li className="nav-item bg-white">
                  <Link to={"/"} className="nav-link active home-topic">
                    صفحه اصلی
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Items */}
          <div className="col-2 text-end d-none d-lg-block">
            {isLoggedIn() ? (
              <div className="user-dropdown-container" dir="rtl">
                <img
                  src={UsrProfImg}
                  alt="Profile"
                  role="button"
                  onClick={handleUserIconClick}
                  className="img-fluid rounded-circle ms-auto me-3 mt-1 d-block dropdown-user-avatar"
                  style={{ cursor: "pointer", width: "40px", height: "40px" }}
                />

                {anchorElUser && (
                  <div className="custom-dropdown">
                    <div className="dropdown-header">
                      <UserInfo
                        fullName={fullName}
                        variant="desktop"
                        onAvatarClick={() => handleNavigation("/user")}
                      />
                    </div>

                    <MenuList
                      items={navMenuItems}
                      onNavigate={handleNavigation}
                      onLogout={handleLogout}
                      variant="desktop"
                    />
                  </div>
                )}
              </div>
            ) : (
              <button
                className="profile-btn"
                onClick={() => navigate("/login")}
              >
                ورود | ثبت نام
              </button>
            )}
          </div>

          {/* Mobile mode */}
          <div className="profile-container d-flex align-items-center d-lg-none">
            <button
              className="border-0 bg-transparent d-flex align-items-center fs-1 color-blue"
              id="profileBtn"
              data-bs-toggle="offcanvas"
              data-bs-target="#profileOffcanvas"
              aria-controls="profileOffcanvas"
            >
              <FontAwesomeIcon className="pe-1" icon={faBars} />
            </button>

            <NavbarMobile />
          </div>
        </div>
      </nav>

      {/* Backdrop for closing dropdown */}
      {anchorElUser && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
            background: "transparent",
          }}
          onClick={handleClose}
        />
      )}
    </>
  );
};

export default Navbar;
